import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-house-name-and-features"
}
const _hoisted_2 = { class: "house-and-builder-wr" }
const _hoisted_3 = { class: "house-name" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "house-details-wr" }
const _hoisted_6 = { class: "content-row" }
const _hoisted_7 = { class: "value-row" }
const _hoisted_8 = { class: "content-row" }
const _hoisted_9 = { class: "value-row" }
const _hoisted_10 = { class: "content-row" }
const _hoisted_11 = { class: "value-row" }
const _hoisted_12 = { class: "price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.houseInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($setup.props.houseInfo.name), 1),
          ($setup.builder)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "builder-logo",
                src: $setup.builder.logo
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createVNode($setup["HouseFeatures"], {
          features: $setup.props.houseInfo,
          directionLogoLandPackage: true,
          iconSize: 'tiny-min',
          class: _normalizeClass('house-features')
        }, null, 8, ["features"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "label-row" }, "Area", -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatPrice($setup.props.houseInfo.area, false)) + " sqm", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label-row" }, "Width", -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.formatPrice($setup.props.houseInfo.width, false)) + " m", 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label-row" }, "Build Price", -1)),
            _createElementVNode("div", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "from" }, "From", -1)),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.buildPriceWithFacade) + "*", 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}